import { TitleIcon } from '@lst/mk-fe-design-system';
import equal from 'fast-deep-equal/react';
import get from 'lodash/get';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { State } from '~/Reducers';

const nationsMapSelector = (state: State) => state.ReducerApp.nationsMap;

export interface Flag_Props {
  nation: string;
  className?: string;
}

const Flag = (props: Flag_Props) => {
  const nationsMap = useSelector<State, NationsMap>(nationsMapSelector, equal);
  const { nation } = props;
  const iconSrc = get(nationsMap, `[${nation}].icons.tiny`, undefined);

  return <TitleIcon iconSrc={iconSrc} size="m" />;
};

export default memo(Flag, equal);
